export const colorHexValues: Record<string, string | undefined> = {
	'indian red': '#B0171F',
	crimson: '#DC143C',
	lightpink: '#FFB6C1',
	pink: '#FFC0CB',
	palevioletred: '#DB7093',
	lavenderblush: '#FFF0F5',
	hotpink: '#FF69B4',
	raspberry: '#872657',
	deeppink: '#FF1493',
	mediumvioletred: '#C71585',
	violetred: '#D02090',
	orchid: '#DA70D6',
	thistle: '#D8BFD8',
	plum: '#DDA0DD',
	violet: '#EE82EE',
	magenta: '#FF00FF',
	fuchsia: '#FF00FF',
	darkmagenta: '#8B008B',
	purple: '#800080',
	mediumorchid: '#BA55D3',
	darkviolet: '#9400D3',
	darkorchid: '#9932CC',
	indigo: '#4B0082',
	blueviolet: '#8A2BE2',
	mediumpurple: '#9370DB',
	darkslateblue: '#483D8B',
	lightslateblue: '#8470FF',
	mediumslateblue: '#7B68EE',
	slateblue: '#6A5ACD',
	ghostwhite: '#F8F8FF',
	lavender: '#E6E6FA',
	blue: '#0000FF',
	mediumblue: '#0000CD',
	darkblue: '#00008B',
	navy: '#000080',
	midnightblue: '#191970',
	cobalt: '#3D59AB',
	royalblue: '#4169E1',
	cornflowerblue: '#6495ED',
	lightsteelblue: '#B0C4DE',
	lightslategray: '#778899',
	slategray: '#708090',
	dodgerblue: '#1E90FF',
	aliceblue: '#F0F8FF',
	steelblue: '#4682B4',
	lightskyblue: '#87CEFA',
	skyblue: '#87CEEB',
	deepskyblue: '#00BFFF',
	peacock: '#33A1C9',
	lightblue: '#ADD8E6',
	powderblue: '#B0E0E6',
	cadetblue: '#5F9EA0',
	darkturquoise: '#00CED1',
	azure: '#F0FFFF',
	lightcyan: '#E0FFFF',
	paleturquoise: '#AEEEEE',
	darkslategray: '#2F4F4F',
	cyan: '#00FFFF',
	aqua: '#00FFFF',
	darkcyan: '#008B8B',
	teal: '#008080',
	mediumturquoise: '#48D1CC',
	lightseagreen: '#20B2AA',
	manganeseblue: '#03A89E',
	turquoise: '#40E0D0',
	coldgrey: '#808A87',
	turquoiseblue: '#00C78C',
	aquamarine: '#7FFFD4',
	mediumaquamarine: '#66CDAA',
	mediumspringgreen: '#00FA9A',
	mintcream: '#F5FFFA',
	springgreen: '#00FF7F',
	mediumseagreen: '#3CB371',
	seagreen: '#2E8B57',
	emeraldgreen: '#00C957',
	mint: '#BDFCC9',
	cobaltgreen: '#3D9140',
	honeydew: '#F0FFF0',
	darkseagreen: '#8FBC8F',
	palegreen: '#98FB98',
	lightgreen: '#90EE90',
	limegreen: '#32CD32',
	forestgreen: '#228B22',
	lime: '#00FF00',
	green: '#008000',
	darkgreen: '#006400',
	sapgreen: '#308014',
	lawngreen: '#7CFC00',
	chartreuse: '#7FFF00',
	greenyellow: '#ADFF2F',
	darkolivegreen: '#556B2F',
	olivedrab: '#6B8E23',
	yellowgreen: '#9ACD32',
	ivory: '#FFFFF0',
	beige: '#F5F5DC',
	lightyellow: '#FFFFE0',
	lightgoldenrodyellow: '#FAFAD2',
	yellow: '#FFFF00',
	warmgrey: '#808069',
	olive: '#808000',
	darkkhaki: '#BDB76B',
	khaki: '#F0E68C',
	palegoldenrod: '#EEE8AA',
	lemonchiffon: '#FFFACD',
	banana: '#E3CF57',
	gold: '#FFD700',
	cornsilk: '#FFF8DC',
	goldenrod: '#DAA520',
	darkgoldenrod: '#B8860B',
	orange: '#FF8000',
	floralwhite: '#FFFAF0',
	oldlace: '#FDF5E6',
	wheat: '#F5DEB3',
	moccasin: '#FFE4B5',
	papayawhip: '#FFEFD5',
	blanchedalmond: '#FFEBCD',
	navajowhite: '#FFDEAD',
	eggshell: '#FCE6C9',
	tan: '#D2B48C',
	brick: '#9C661F',
	cadmiumyellow: '#FF9912',
	antiquewhite: '#FAEBD7',
	burlywood: '#DEB887',
	bisque: '#FFE4C4',
	melon: '#E3A869',
	carrot: '#ED9121',
	darkorange: '#FF8C00',
	peru: '#CD853F',
	linen: '#FAF0E6',
	peachpuff: '#FFDAB9',
	seashell: '#FFF5EE',
	sandybrown: '#F4A460',
	rawsienna: '#C76114',
	chocolate: '#D2691E',
	saddlebrown: '#8B4513',
	ivoryblack: '#292421',
	flesh: '#FF7D40',
	cadmiumorange: '#FF6103',
	burntsienna: '#8A360F',
	sienna: '#A0522D',
	lightsalmon: '#FFA07A',
	coral: '#FF7F50',
	orangered: '#FF4500',
	sepia: '#5E2612',
	darksalmon: '#E9967A',
	burntumber: '#8A3324',
	tomato: '#FF6347',
	salmon: '#FA8072',
	mistyrose: '#FFE4E1',
	snow: '#FFFAFA',
	rosybrown: '#BC8F8F',
	lightcoral: '#F08080',
	indianred: '#CD5C5C',
	brown: '#A52A2A',
	firebrick: '#B22222',
	red: '#FF0000',
	darkred: '#8B0000',
	maroon: '#800000',
	'sgi beet': '#8E388E',
	'sgi slateblue': '#7171C6',
	'sgi lightblue': '#7D9EC0',
	'sgi teal': '#388E8E',
	'sgi chartreuse': '#71C671',
	'sgi olivedrab': '#8E8E38',
	'sgi brightgray': '#C5C1AA',
	'sgi salmon': '#C67171',
	'sgi darkgray': '#555555',
	'sgi lightgray': '#AAAAAA',
	white: '#FFFFFF',
	'white smoke': '#F5F5F5',
	gainsboro: '#DCDCDC',
	lightgrey: '#D3D3D3',
	silver: '#C0C0C0',
	darkgray: '#A9A9A9',
	gray: '#808080',
	dimgray: '#696969',
	black: '#000000',
	whitesmoke: '#F5F5F5'
};
